export const fileToPayload = async (file: File): Promise<any> => {
  const bytes = await file.arrayBuffer();
  const binary = Array.from(new Uint8Array(bytes));
  const base64 = btoa(
    binary.map((b) => String.fromCharCode(b)).join(''),
  );

  return {
    fnm: file.name,
    mtp: file.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    fsz: file.size,
    fdt: base64,
  };
};
